export default __webpack_public_path__ + "static/media/rambouillet07.bc16951a.jpg";